import { Component, computed, input } from '@angular/core';
import { HwdConfigService } from '../../hwd-config.service';
import { HwdSysteem, Rack } from '../../hdw-config/HdwSysteem';
import { isSysteemKaart, KaartType } from '../../hdw-config/hdw-konfig-types';
import { EditSystemService } from '../edit-system.service';
import { trashIcon } from "@progress/kendo-svg-icons";
import { CdkDragDrop } from '@angular/cdk/drag-drop';

@Component({
  selector: 'rack-view',
  templateUrl: './rack-view.component.html',
  styleUrl: './rack-view.component.scss'
})
export class RackViewComponent {

  constructor(public hdwMetaService: HwdConfigService, public editSystem: EditSystemService) { }

  public icon = trashIcon;

  public rack = input.required<Rack>();
  public editDipSwitch = input<boolean>(false);

  public slotKaarten() {
    return this.rack().kaarten.filter(k => k.type.takesRackSpace);
  };

  public kartTypes = computed(() => {
    let mainboard = this.editSystem.system()?.mainboard;
    if (mainboard != undefined) {
      return mainboard.kaartTypes.filter(k => k.bus == this.rack().type.bus);
    }
    return [];
  });

  public canDelete = computed(() => {
    let system = this.editSystem.system();
    if (system == undefined) {
      return false;
    }
    return system.canDeleteRack(this.rack().id, this.rack().type.bus);
  });

  async onKaartAdded(e: KaartType) {
    let nr = this.rack().getNextNumber();

    this.editSystem.system.update(_system => {
      if (_system != undefined) {
        _system.addKaart(e, nr, this.rack().id);
      }
      return _system;
    })
  }

  public onDelete() {
    this.editSystem.system.update(_system => {
      if (_system != undefined) {
        _system.deleteRack(this.rack().id, this.rack().type.bus);
      }
      return _system;
    });
  }

  onDrop(e: CdkDragDrop<any[]>) {
    this.rack().moveKaart(e.previousIndex, e.currentIndex);
  }


}
